// src/pages/ManualMarketing/ManualMarketingGallery/Step2.jsx

import React, { useState, useEffect } from "react";
import { HeaderIconL } from "../../../assets/components/HeaderGroup";
import {
  FillButton,
  GrayButton,
} from "../../../assets/components/ButtonGroup";
import PlaceholderB from "../../../assets/components/PlaceholderB";
import arrowleft from "../../../assets/icons/Arrow/left.svg";
import { Chip } from "../../../assets/components/Chip";
import {
  fetchSiksinMenus,
  fetchSiksinMenusByBusinessNumber,
} from "../../../utils/siksinMenus";
import { getEffectiveRepresentativeMenus } from "../../../utils/representativeMenus";

const Step2 = ({
  data = {},
  userMenu,
  localStoreId,
  storeBusinessNumber,
  updateData,
  onNext,
  onBack,
  onHome,
}) => {
  const normalizeUserMenu = (value) => {
    if (value === null || value === undefined || value === "null") return "";
    return String(value);
  };

  const [value, setValue] = useState(normalizeUserMenu(userMenu));
  const [recommendedMenus, setRecommendedMenus] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);

  useEffect(() => {
    const nextValue = normalizeUserMenu(userMenu);
    setValue(nextValue);

    const matched = recommendedMenus.find((m) => m === nextValue) || null;
    setSelectedMenu(matched);
  }, [userMenu]);

  useEffect(() => {
    let alive = true;

    (async () => {
      const registerTag = localStorage.getItem("registerTag") || "";
      const menus = localStoreId
        ? await fetchSiksinMenus(localStoreId)
        : await fetchSiksinMenusByBusinessNumber(storeBusinessNumber);
      if (!alive) return;
      const effective = getEffectiveRepresentativeMenus({
        storeBusinessNumber,
        dbMenus: Array.isArray(menus) ? menus : [],
        registerTag,
      });

      const nextRecommended = Array.isArray(effective) ? effective : [];
      setRecommendedMenus(nextRecommended);

      const matched = nextRecommended.find((m) => m === value) || null;
      setSelectedMenu(matched);
    })();

    return () => {
      alive = false;
    };
  }, [localStoreId, storeBusinessNumber]);

  const trimmed = value.trim();
  const isValid = trimmed.length > 0;

  // Placeholder onChange 대응: string / event / { value } 다 처리
  const handleChange = (next) => {
    let nextValue = "";

    if (typeof next === "string") {
      nextValue = next;
    } else if (next && typeof next === "object") {
      if (typeof next.target?.value === "string") {
        nextValue = next.target.value;
      } else if (typeof next.value === "string") {
        nextValue = next.value;
      }
    }

    setValue(nextValue);
    setSelectedMenu(nextValue === selectedMenu ? selectedMenu : null);
    updateData?.({
      customMenu: nextValue,
      category: "",
    });
  };

  const applyMenu = (menu) => {
    const nextValue = String(menu || "");
    setSelectedMenu(nextValue);
    setValue(nextValue);
    updateData?.({
      customMenu: nextValue,
      category: "",
    });
  };

  const handleNext = () => {
    if (!isValid) return;

    updateData?.({
      customMenu: trimmed,
      category: "",
    });

    onNext?.();
  };

  const handleBack = () => {
    if (onBack) return onBack();
    if (onHome) return onHome();
  };

  return (
    <div className="flex flex-col min-h-dvh bg-[var(--surface-default)]">
      {/* 헤더 */}
      <HeaderIconL
        title="사진 업로드"
        icon={arrowleft}
        onIconClick={handleBack}
      />

      {/* 컨텐츠 */}
      <main className="flex-1 px-[16px] pt-[16px]">
        <h2 className="text-t2 font-semibold text-text-default">
          사진에 대해 한 줄로 알려주세요!
        </h2>

        <p className="mt-2 text-b2 text-text-subtle">
          무엇을 찍었는지(상품/메뉴)만 적어도 충분해요.
        </p>

        <div className="mt-6">
          <PlaceholderB
            label="상품명"
            placeholder="예) 삼겹살/아메리카노/송편"
            maxLength={20}
            showCounter
            value={value}
            onChange={handleChange}
            rightIconMode="clear"
          />
        </div>

        {recommendedMenus.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-2">
            {recommendedMenus.map((m) => (
              <Chip
                key={m}
                chip="d"
                status={m === selectedMenu ? "selected" : "default"}
                className={
                  m === selectedMenu
                    ? "bg-surface-light-white border-black text-black"
                    : ""
                }
                label={m}
                onClick={() => applyMenu(m)}
              />
            ))}
          </div>
        )}
      </main>

      {/* 하단 버튼 */}
      <div>
        {isValid ? (
          <FillButton onClick={handleNext}>다음</FillButton>
        ) : (
          <GrayButton disabled>다음</GrayButton>
        )}
      </div>
    </div>
  );
};

export default Step2;
